import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import MovieGrid from "../MovieGrid";
import i18n from "../../../config/i18n";

interface GridSectionProps {
  title?: string;          // expected: "Phim hot"
  movies: any[];
  type?: string;           // "lists"
  posttype?: string;       // "movie"
  api?: string;            // "/posts/lists/movie/"
  iconUrl?: string;
  onClickViewMore?: () => void; // Optional function to handle view more action
  isSelectMode?: boolean; // thêm prop
  selectedIds?: string[]; // thêm prop
  onSelectMovie?: (id: string) => void; // thêm prop
}

const GridSection: React.FC<GridSectionProps> = ({
  title,
  movies,
  api,
  type,
  posttype,
  iconUrl,
  onClickViewMore,
  isSelectMode = false,
  selectedIds = [],
  onSelectMovie
}) => {
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || window.location.hash.split('/')[1] || i18n.options.fallbackLng;
  
  return (
    <div>
      {title && (<div className="flex justify-between items-center mx-4 mb-4">
        <h2 className="text-xl font-bold text-white">{title}</h2>
        <div className="flex items-center" onClick={() => {
          if (onClickViewMore) {
            onClickViewMore();
          } else if (type && posttype) {
            navigate(`/${currentLang}/${type}/${posttype}/lists`);
          }
        }}>
          <span className="btn-link text-[12px] text-white">
            Xem thêm
          </span>
          <div className="flex items-center justify-center w-6 h-6">
            <img src={"/assets/icons/right-icon.svg"} alt="Arrow" />
          </div>
        </div>
      </div>)}
      
      {movies.length > 0 && (
        <MovieGrid
          movies={movies}
          size="small"
          isSelectMode={isSelectMode}
          selectedIds={selectedIds}
          onSelectMovie={onSelectMovie}
        />
      )}
    </div>
  );
};

export default GridSection;
